import React from 'react';
import { IssueFieldStatisticsButton } from '@atlassian/jira-business-issue-field-statistics';

const IssueFieldStatisticsButtonWrapper = () => {
	return <IssueFieldStatisticsButton />;
};

export default IssueFieldStatisticsButtonWrapper;
